import { Navigate } from 'react-router-dom';
import Kyc from '@/pages/Kyc';
import KycProvider from '@/pages/Kyc/KycProvider';
import KycVerify from '@/pages/Kyc/KycVerify';

const kycRoutes = [
  {
    path: '/kyc',
    element: <Kyc />,
    children: [
      { index: true, element: <Navigate to="provider" replace /> },
      { path: 'provider', element: <KycProvider /> },
      { path: 'verify', element: <KycVerify /> },
    ],
  },
];

export default kycRoutes;
